/** Active Supabase auth user id - required for reading/writing learning data. */
let activeUserId = null;

export function getActiveStudentUserId() {
  return activeUserId;
}

/** @param {string | null} userId */
export function setActiveStudentUserId(userId) {
  activeUserId = userId || null;
}

export function isStudentProfileWritable() {
  return Boolean(activeUserId);
}
